import React from "react";
import { YhModal } from "../../../ui/YhModal";
import { YhButton } from "../../../ui/YhButton";

interface ConfirmationDialogProps {
  open: boolean;
  title: string;
  description: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmButtonText?: string;
  cancelButtonText?: string;
}

const ConfirmationModel: React.FC<ConfirmationDialogProps> = ({
  open,
  title,
  description,
  onConfirm,
  onCancel,
  confirmButtonText = "Confirm",
  cancelButtonText = "Cancel",
}) => {
  return (
    <YhModal
      open={open}
      onClose={onCancel}
      title={title}
      width={420}
      footer={
        <>
          <YhButton variant="secondary" fullWidth={false} onClick={onCancel}>
            {cancelButtonText}
          </YhButton>
          <YhButton variant="danger" fullWidth={false} onClick={onConfirm}>
            {confirmButtonText}
          </YhButton>
        </>
      }
    >
      <p className="text-sm text-yh-secondary-text">{description}</p>
    </YhModal>
  );
};

export default ConfirmationModel;
